class IntersectionManager {
  constructor (view) {
    this.threshold = [0]
    this.view = view
    this.components = []

    this.scrapSubComponent()
    this.init()
  }

  scrapSubComponent () {
    this.findInChildren(this.view.$children)
  }

  findInChildren (node) {
    for (let i = 0; i < node.length; i++) {
      const n = node[i]
      if (n.needIntersection == true) {
        this.components.push(n)
      }
      this.findInChildren(n.$children)
    }
  }

  init () {
    this.observer = new IntersectionObserver(this.onIntersection.bind(this),
      {
        threshold: this.threshold
      })
    for (let i = 0; i < this.components.length; i++) {
      const comp = this.components[i]
      this.observer.observe(comp.$el)
    }
  }

  onIntersection (entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target._show()
      }
    }
  }
}

export default IntersectionManager
